import Vue from 'vue'
import Router from 'vue-router'
import ApiMenu from '../apis/api-menu'
import MenuTree from '../common/menu-tree'
import Layout from '../components/layout'
import Tool from '../common/tool'

Vue.use(Router)
let list = []
Tool.walkTree(MenuTree, function (node) {
  list.push({ path: node.path, name: node.name, layout: Layout })
})
let routeList = []
for (let i in list) {
  let item = list[i]
  if (item.layout) {
    routeList.push({
      path: item.path,
      meta: { title: item.name },
      component: item.layout,
      redirect: item.path,
      children: [{
        path: item.path,
        name: item.name,
        meta: { title: item.name },
        component: () => import(/* webpackChunkName: "[request]" *//* webpackPrefetch: true */`../pages${item.path}`)
      }]
    })
  } else {
    routeList.push({
      path: item.path,
      name: item.name,
      meta: { title: item.name },
      component: () => import(/* webpackChunkName: "[request]" *//* webpackPrefetch: true */`../pages${item.path}`)
    })
  }
}
export default new Router({
  routes: [
    { path: '/index/home', name: '首页', meta: { title: '首页' }, component: require('@/pages/index/home').default },
    { path: '/index/login', name: '登录', meta: { title: '登录' }, component: require('@/pages/index/login').default },
    { path: '/index/login-pwd', name: '密码登录', meta: { title: '密码登录' }, component: require('@/pages/index/login-pwd').default },
    { path: '/index/register', name: '注册', meta: { title: '注册' }, component: require('@/pages/index/register').default },
    { path: '/index/register-email', name: '邮箱注册', meta: { title: '邮箱注册' }, component: require('@/pages/index/register-email').default },
    ...routeList,
    // ...ApiMenu.getMenuRouter(),
    { path: '/index/404', name: '404', meta: { title: '404' }, component: () => import(/* webpackChunkName: "[request]" *//* webpackPrefetch: true */`../pages/index/404`) },
    { path: '/index/test', name: '测试页面', meta: { title: '测试页面' }, component: () => import(/* webpackChunkName: "[request]" *//* webpackPrefetch: true */`../pages/index/test`) },
    { path: '/index/test2', name: '测试页面2', meta: { title: '测试页面2' }, component: () => import(/* webpackChunkName: "[request]" *//* webpackPrefetch: true */`../pages/index/test2`) },
    { path: '*', name: '找不到页面', meta: { title: '登录' }, redirect: '/index/login' }
  ]
})
